import styled from "styled-components";

export const ErrorText = styled.span`
  margin: 2px 5px;
  font-size: 0.6rem;
  color: red;
`;
